import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import moment from "moment";

const PrintManageVouchers = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(true);
  const [listOfVouchers, setVouchers] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [grandTotalDebit, setGrandTotalDebit] = useState(0);
  const [grandTotalCredit, setGrandTotalCredit] = useState(0);
  const [isGrandBalanced, setIsGrandBalanced] = useState(true);
  const [filterLabel, setFilterLabel] = useState("");

  const fmtAmt = (v) =>
    Number(v || 0).toLocaleString(undefined, { maximumFractionDigits: 2 });

  useEffect(() => {
    document.title = "Print Manage Vouchers";

    const urlParams = new URLSearchParams(window.location.search);
    const defaultFYear = urlParams.get("DefaultYear") || "";
    const voucherTypeId = parseInt(urlParams.get("VoucherTypeID") || "0", 10) || 0;
    const voucherNo = urlParams.get("VoucherNo") || "";
    const startDate = urlParams.get("StartDate") || "";
    const endDate = urlParams.get("EndDate") || "";

    const parts = [`Year ${defaultFYear}`];
    if (voucherTypeId > 0) parts.push(`Type ID ${voucherTypeId}`);
    if (voucherNo) parts.push(`Voucher no contains "${voucherNo}"`);
    if (startDate) parts.push(`From ${startDate}`);
    if (endDate) parts.push(`To ${endDate}`);
    setFilterLabel(parts.join(" · "));

    axios({
      method: "post",
      url: config.base_url + "Voucher/GetVouchersByYear",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: parseInt(defaultFYear, 10) || 0,
        VoucherTypeID: voucherTypeId,
        VoucherNo: voucherNo,
        StartDate: startDate || null,
        EndDate: endDate || null,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1) {
          setVouchers(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          setGrandTotalDebit(response.data.GrandTotalDebit ?? 0);
          setGrandTotalCredit(response.data.GrandTotalCredit ?? 0);
          setIsGrandBalanced(response.data.IsGrandBalanced !== false);
        } else {
          setVouchers([]);
          setTotalRecords(0);
          setGrandTotalDebit(0);
          setGrandTotalCredit(0);
          setIsGrandBalanced(true);
        }
        setLoading(false);
      })
      .catch(() => {
        setVouchers([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderRows = () => {
    if (listOfVouchers.length > 0) {
      let count = 1;
      return listOfVouchers.map((item, index) => (
        <tr key={index}>
          <td>{count++}</td>
          <td>{item.ID}</td>
          <td>{item.Voucher_code}</td>
          <td>{item.Voucher_number}</td>
          <td>{moment(item.Voucher_date).format("DD/MM/YYYY")}</td>
          <td className="text-center">{item.FYear}</td>
          <td className="text-end">{fmtAmt(item.TotalDebit)}</td>
          <td className="text-end">{fmtAmt(item.TotalCredit)}</td>
          <td>{item.Remarks}</td>
          <td className="text-center">
            {item.IsBalanced === false ? "Unbalanced" : ""}
          </td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={10}>
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <Page orientation="landscape" size="a4">
      <PrintHeader title="Manage Vouchers" />
      {filterLabel ? (
        <p className="small mb-2" style={{ fontSize: "10pt" }}>
          {filterLabel}
        </p>
      ) : null}
      {!loading && totalRecords > 0 && !isGrandBalanced && (
        <p className="small mb-2 text-danger" style={{ fontSize: "10pt" }}>
          Grand debit and credit do not match. Difference:{" "}
          {fmtAmt(Math.abs(grandTotalDebit - grandTotalCredit))}
        </p>
      )}
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th colSpan={10} className="text-end">
              Total records: {totalRecords}
            </th>
          </tr>
          <tr>
            <th>Sr#</th>
            <th>ID</th>
            <th>Code</th>
            <th>Voucher No</th>
            <th>Dated</th>
            <th className="text-center">Year</th>
            <th className="text-end">Total Debit</th>
            <th className="text-end">Total Credit</th>
            <th>Details</th>
            <th className="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan={10}>
                <Spinner animation="border" role="status" />
              </td>
            </tr>
          ) : (
            <>
              {renderRows()}
              {listOfVouchers.length > 0 && (
                <tr>
                  <th colSpan={6} className="text-end">
                    Grand total
                  </th>
                  <th className="text-end">{fmtAmt(grandTotalDebit)}</th>
                  <th className="text-end">{fmtAmt(grandTotalCredit)}</th>
                  <th colSpan={2}>
                    {!isGrandBalanced
                      ? `Diff ${fmtAmt(Math.abs(grandTotalDebit - grandTotalCredit))}`
                      : ""}
                  </th>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default PrintManageVouchers;
